// extracted by mini-css-extract-plugin
export default {"cls1":"rlW5uJmbvqzsKKKqu7Yr","cls2":"Eadb8AQDQUgAcGCcmQGn rlW5uJmbvqzsKKKqu7Yr","isPhone":"M8U74Esdv__NibcR7obh"};